import { FrontendFormContext } from "@/common/contexts/FrontendFormContext";
import { OfflinePaymentMethod } from "./OfflinePaymentMethod/OfflinePaymentMethod";
import { FC, useContext } from "react";

import { Box } from "@mui/material";
import { countryHasPad, OrganizationCountry, countryHasAch, PaymentMethod } from "@simplyk/common";

import { CreditCardFormPaymentMethod } from "@/forms-design-system/FormPaymentMethod";
import { AchFormPaymentMethod } from "@/forms-design-system/FormPaymentMethod/AchFormPaymentMethod";
import { PadFormPaymentMethod } from "@/forms-design-system/FormPaymentMethod/PadFormPaymentMethod";

// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- Public-form components consume the editor preview context.
import { usePreviewContext } from "@/features/LiveFormEditor/LivePreview/contexts/PreviewContext";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- Match the editor's disabled preview styling.
import { GHOST_PREVIEW_OPACITY } from "@/features/LiveFormEditor/LivePreview/ghostPreview.constant";

interface PreviewPaymentMethodsProps {
  country: OrganizationCountry;
}

export const PreviewPaymentMethods: FC<PreviewPaymentMethodsProps> = ({ country }) => {
  const { formData } = useContext(FrontendFormContext);
  const { disabledAdvancedSetting } = usePreviewContext();
  const isDafGhost = disabledAdvancedSetting === "dafEnabled";
  const isChequeGhost = disabledAdvancedSetting === "chequeEnabled";
  const showCheque = typeof formData.chequeMinimumAmount === "number" || isChequeGhost;
  const showDaf = Boolean(
    "dafEnabled" in formData && (formData.dafEnabled || isDafGhost) && formData.organization?.isDafEligible
  );
  return (
    <Box>
      <CreditCardFormPaymentMethod />
      {countryHasPad(country) && <PadFormPaymentMethod />}
      {countryHasAch(country) && <AchFormPaymentMethod />}
      {showCheque && (
        <Box id="payment-method-cheque" sx={{ opacity: isChequeGhost ? GHOST_PREVIEW_OPACITY : 1 }}>
          <OfflinePaymentMethod paymentMethod={PaymentMethod.Cheque} />
        </Box>
      )}
      {showDaf && (
        <Box id="payment-method-daf" sx={{ opacity: isDafGhost ? GHOST_PREVIEW_OPACITY : 1 }}>
          <OfflinePaymentMethod paymentMethod={PaymentMethod.Daf} />
        </Box>
      )}
    </Box>
  );
};
